<template>
    <div class="row d-flex flex-row align-items-center" v-if="$props.data.length > 0 || $props.pageIndex > 0">
        <nav class="col-auto flex-grow-1">
            <ul class="pagination">

                <li class="page-item" :class="{ disabled: firstPage }">
                    <a class="page-link" href="#" @click="prevPage">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>

                <li class="page-item active">
                    <a class="page-link" href="#">{{ pageIndex + 1 }}</a>
                </li>

                <li class="page-item" :class="{ disabled: disableNext }">
                    <a class="page-link" href="#" @click="nextPage">
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: "CustomPagination",
    props: {
        data: { type: Array, required: true },
        pageIndex: { type: Number, default: 0 },
        pageSize: { type: Number, default: 20 },
        disableNext: { type: Boolean, default: false }
    },
    methods: {
        prevPage() {
            if (this.pageIndex > 0) {
                this.$emit("page-change", this.pageIndex - 1);
            }
        },
        nextPage() {
            if (!this.disableNext) { 
                this.$emit("page-change", this.pageIndex + 1);
            }
        }
    },
    computed: {
        firstPage() {
            return this.pageIndex === 0;
        }
    }
};
</script>

<style scoped>
.pagination {
    margin: 0;
}
</style>
